export const SET_FORM_DATA_EVENT = "set-form-data";
export const FEEDBACK_WIDGET_LOAD_EVENT = "feedback-widget-load";
export const FEEDBACK_WIDGET_CONTAINER_ID = "awsc-aperture-widget-modal-container";
export interface Metadata {
  key: string;
  value: string;
}

/**
 * category, name, version
 *  - Details to identify the form.
 * metadataList
 *  - Optional properties sent along with the form.
 * feedbackReference
 *  - Used to identify service. Defaulted to nav id.
 * feedbackTitle
 *  - Title of the form. Defaulted to "Feedback for {service name}".
 * simFolderId
 *  - SIM folder ID where form response tickets will populate.
 * https://w.amazon.com/bin/view/AWS-UIS/Aperture/Documentation/UserGuide/
 */
export interface CustomFormData {
  category: string;
  name: string;
  version: string;
  metadataList?: Metadata[];
  feedbackReference?: string;
  feedbackTitle?: string;
  simFolderId?: string;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type ApertureWidgetLoadCallback = (...args: any[]) => void;
